import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import Main from '../layout/Main';
import Users from '../../pages/Users';
import UserPage from '../../pages/AccountSummary';
import UserJsonPage from '../../pages/UserJsonPage';
import MerchantsList from '../layout/AccountSummary/Merchants';

const AppContainer = () => {
    return (
        <Main>
            <Switch>
                <Route
                    exact
                    path="/users"
                    component={Users}
                />
                <Route
                    exact
                    path="/merchants"
                    component={MerchantsList}
                />
                <Route
                    exact
                    path="/user/:userId"
                    // Rebuild the page per user so nothing from the previous account can linger
                    render={(props) => <UserPage key={props.match.params.userId} {...props} />}
                />
                <Route
                    exact
                    path="/user-json/:userId"
                    component={UserJsonPage}
                />
                <Redirect from="/" to={'/users'} />
            </Switch>
        </Main>
    );
};

export default AppContainer;
